module.exports = __webpack_public_path__ + "static/media/grayscale.bca7cae4.jpg";